import { BridgeComponent } from "@hotwired/hotwire-native-bridge"

export default class extends BridgeComponent {
  static component = "settings-button"
  static values = { email: String }

  connect() {
    super.connect()
    this.send("connect", { title: "Ajustes", url: this.configUrl, email: this.emailValue })
  }

  get configUrl() {
    return `${window.location.origin}/configuracion`
  }
}
